import { OrganizationStatusBadge } from './OrganizationStatusBadge';
import './OrganizationPause.css';

interface OrganizationPausedBannerProps {
  pausedAt: string | null;
  /** The raw custom message, or null when users see the server default. */
  pausedMessage: string | null;
}

const formatPausedAt = (dateString: string | null) => {
  if (!dateString) return 'an unknown time';
  return new Date(dateString).toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
};

/** Explains, on the org detail page, that this organization is currently paused. */
export const OrganizationPausedBanner = ({
  pausedAt,
  pausedMessage,
}: OrganizationPausedBannerProps) => (
  <div className="org-pause-banner" role="status" data-testid="org-paused-banner">
    <OrganizationStatusBadge isPaused />
    <div className="org-pause-banner__body">
      <p className="org-pause-banner__text">
        Paused on {formatPausedAt(pausedAt)}. Users in this organization are blocked from
        RosterPilot until it is resumed.
      </p>
      <p className="org-pause-banner__text">
        {pausedMessage
          ? `Custom message shown to users: "${pausedMessage}"`
          : 'Users see the default paused message.'}
      </p>
    </div>
  </div>
);
